import styled from "@emotion/styled"
import parse from "html-react-parser"
import { body50, bold, light } from "css/text"
import Link from "components/link/Link"

import getMediaQuery from "css/breakpoints"

export const Para = styled.p`
  ${body50}
  ${light}
  margin-block-start: 1em;
  margin-block-end: 1em;
  font-size: inherit;

  ${getMediaQuery("s", { max: true })} {
    word-wrap: break-word;
  }

  &.last-child {
    margin-block-end: 0;
  }

  b {
    ${bold}
  }
`
const External = styled(Link)`
  svg {
    display: none;
  }
  font-weight: bold;
`

export default function LegalParagraph({ paragraph }) {
  console.log("🚀 ~ LegalParagraph ~ paragraph:", paragraph)
  const transformHtml = html => {
    return parse(html, {
      replace: node => {
        if (node.name === "a") {
          const href = node.attribs.href
          const label = node.children[0].data

          return href.includes("http") ? (
            <External external={href} rel='noopener noreferrer'>
              {label}
            </External>
          ) : (
            <Link icon='none' href={href}>
              {label}
            </Link>
          )
        }
      },
    })
  }

  return paragraph.map((p, i) => (
    <Para key={`legal-para-${i}`} className={i + 1 === paragraph.length ? "last-child" : null}>
      {transformHtml(p)}
    </Para>
  ))
}
